const React = require('react');
require('date-fns');
const {
  MuiPickersUtilsProvider,
  DatePicker,
} = require('@material-ui/pickers');
const DateFnsUtils = require('@date-io/date-fns').default;


module.exports = (props) => {
  const {
    data,
    onChange,
  } = props;
  const disabled = props.disabled || false;
  const {
    from,
    to,
  } = data;

  const _to = to ? new Date(to) : new Date();
  let _from = new Date(from || 0);
  _from && _to && _from.getTime() > _to.getTime() && (_from = _to);
  
  return (
    <div className={`layoutRow fhaC fvaC ` + (props.className || '')}>
      <InputDate
        disabled={disabled}
        value={_from}
        minDate={new Date(1605185763100)}
        maxDate={_to}
        disableFuture
        onChange={(from) => {
          onChange({
            ...data,
            from: from.getTime(),
          });
        }}
      />
      <ArrowInInterval className="w6"/>
      <InputDate
        disabled={disabled}
        value={_to}
        minDate={_from}
        disableFuture
        onChange={(to) => {
          onChange({
            ...data,
            to: to.getTime(),
          });
        }}
      />
    </div>
  );
};


function InputDate(props) {
  return (
    <MuiPickersUtilsProvider
      utils={DateFnsUtils}
    >
      <DatePicker
        {...props}
        format="dd.MM.yyyy"
        className="z1 cCT>.MuiInputBase-root dN>.MuiInput-underline::(before|after)
          (dB|pv|h18|w96|tc|rlv|olN|f12|ff$3|cr:not[.Mui-disabled]!@mouse)>input"
      />
    </MuiPickersUtilsProvider>
  );
}


/* eslint-disable */
function ArrowInInterval() {
  return (
    <svg
      viewBox="0 0 6 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dB fillCT>path w6"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.16444e-07 11.333L3.88518 6.80034L6.11978e-07 2.26764L7.28422e-07 0.000343323L5.82858 6.80034L0 13.6003L1.16444e-07 11.333Z"
      />
    </svg>
  );
}
